import React from 'react';

import { Row, Col } from 'antd';

import SectionWrapper from 'common/components/section-wrapper/SectionWrapper';
import EditButtonsSection from 'common/components/btn-save-cancel/EditButtonsSection';

const FormSection = (props) => {
  const {
    children,
    title,
    style,
    allowEdit = true,
    styleWrapperButtons = {},
    ...restProps
  } = props;

  return (
    <Row style={{ flexDirection: 'column', height: '100%' }}>
      <Row wrap={false}>
        <Col flex={1}></Col>
        <Col style={styleWrapperButtons}>
          {allowEdit && <EditButtonsSection {...restProps} />}
        </Col>
      </Row>
      <SectionWrapper title={title} style={{ flex: 1, ...style }}>
        {children}
      </SectionWrapper>
    </Row>
  );
};

export default FormSection;
